import { useMemo } from 'react'

import type { Radix } from '#/radixes.ts'
import Table, { Tables } from './table.tsx'

const { isNaN } = Number

export default function Multiply({ radixes }: { radixes: Radix[] }) {
	return (
		<Tables>{ radixes.map(radix =>
			<MultiplyTable radix={radix} key={radix.name}/>) }
		</Tables>
	)
}

function MultiplyTable({ radix }: { radix: Radix }) {
	const { numbers, low, high } = useMemo(() => {
		let { low, high } = radix
		if (low >= 0) {
			low = 2
			if (high < 3) high = 3
		}
		const lowest = low >= 0 ? low : low * high
		const highest = high * high
		const arr = [ NaN, ...Array.from(Array(high - (low - 1)), (_, i) => i + low) ]
		const numbers = arr.map(row => arr.map(col => {
			if (isNaN(row) && isNaN(col)) return NaN
			return isNaN(row) || isNaN(col) ? isNaN(row) ? col : row : row * col
		}))

		return { numbers, low: lowest, high: highest }
	}, [ radix ])

	return <Table radix={radix} numbers={numbers} low={low} high={high}/>
}
